module.exports = __webpack_public_path__ + "media/img/thumbs-up-b9936ed0e1795640aff5daf92cacec1c.svg";